export default __webpack_public_path__ + "static/media/slider_background_image.185eba27.jpg";